<template>
    <div class="container">
        <footer
            class="footer"
            role="contentinfo">
            <ul class="footer__socials">
                <li
                    v-if="facebookUrl"
                    class="footer__socials-item">
                    <a
                        :href="facebookUrl"
                        :title="`Facebook (${$t('new-window')})`"
                        target="_blank"
                        class="footer__socials-link footer__socials-link--icon">
                        <img
                            src="@/assets/images/icons/social/icon-facebook.svg"
                            alt="Facebook">
                    </a>
                </li>
                <li
                    v-if="twitterUrl"
                    class="footer__socials-item">
                    <a
                        :href="twitterUrl"
                        :title="`Twitter (${$t('new-window')})`"
                        target="_blank"
                        class="footer__socials-link footer__socials-link--icon">
                        <img
                            src="@/assets/images/icons/social/icon-twitter.svg"
                            alt="Twitter">
                    </a>
                </li>
                <li
                    v-if="linkedInUrl"
                    class="footer__socials-item">
                    <a
                        :href="linkedInUrl"
                        :title="`LinkedIn (${$t('new-window')})`"
                        target="_blank"
                        class="footer__socials-link footer__socials-link--icon">
                        <img
                            src="@/assets/images/icons/social/icon-linkedin.svg"
                            alt="LinkedIn">
                    </a>
                </li>
                <li
                    v-if="instagramUrl"
                    class="footer__socials-item">
                    <a
                        :href="instagramUrl"
                        :title="`Instagram (${$t('new-window')})`"
                        target="_blank"
                        class="footer__socials-link footer__socials-link--icon">
                        <img
                            src="@/assets/images/icons/social/icon-instagram.svg"
                            alt="Instagram">
                    </a>
                </li>
                <li
                    v-if="blogUrl"
                    class="footer__socials-item footer__socials-link--icon">
                    <a
                        :href="blogUrl"
                        :title="`Blog (${$t('new-window')})`"
                        target="_blank"
                        class="footer__socials-link">
                        <img
                            src="@/assets/images/icons/social/icon-blog.svg"
                            alt="Blog">
                    </a>
                </li>
            </ul>

            <a
                :href="landingUrl"
                class="footer__copyright">
                {{ $t("powered-by") }} <img
                    class="footer__company-logo"
                    alt=""
                    width="30"
                    src="@/assets/images/logos/Logo-Icon.png" /><span class="footer__company-name">{{ $appName }}</span>
            </a>
        </footer>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: "Footer",
    data() {
        return {
            landingUrl: process.env.VUE_APP_LANDIND_PAGE_URL,
            facebookUrl: process.env.VUE_APP_FACEBOOK_URL,
            twitterUrl: process.env.VUE_APP_TWITTER_URL,
            instagramUrl: process.env.VUE_APP_INSTAGRAM_URL,
            linkedInUrl: process.env.VUE_APP_LINKEDIN_URL,
            blogUrl: process.env.VUE_APP_BLOG_URL,
        };
    },
};
</script>